import { useFetchBondRequestPreviews } from "@portal/api/previews";
import { FilterableDataTable } from "@portal/components/ui/FilterableDataTable";
import { useIsMinimalBondUIEnabled } from "@portal/hooks/useIsMinimalBondUIEnabled";
import { FC, useMemo } from "react";
import { getRequestsTableColumns } from "./columns";

export const BondRequestPreviewsClosed: FC = () => {
	const { bondRequestPreviews } = useFetchBondRequestPreviews();
	const isMinimalUIEnabled = useIsMinimalBondUIEnabled();

	const closedBondRequestPreviews = useMemo(() => {
		if (!bondRequestPreviews) return undefined;
		return bondRequestPreviews.filter(({ status }) => status === "closed" || status === "declined");
	}, [bondRequestPreviews]);

	const columns = useMemo(() => getRequestsTableColumns(isMinimalUIEnabled), [isMinimalUIEnabled]);

	return (
		<FilterableDataTable
			name="bond_requests_closed_v2"
			columnDefs={columns}
			getRowUrl={(row) => `/accounts/${row.accountId}/requests/${row.id}`}
			data={closedBondRequestPreviews}
			loadingMessage="Loading bond requests..."
			enableExportToCSV
		/>
	);
};
